import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ReportTicketRepository} from "@dropDesk/domain/repositories/reports/report_ticket/report_ticket.repository";
import {ReportTicketEntity} from "@dropDesk/domain/entities/reports/report_ticket/report_ticket_entity";

@injectable()
export class GetReportTicketUseCase {
  private _repository: ReportTicketRepository;

  constructor(@inject(ReportTicketRepository) repository: ReportTicketRepository) {
    this._repository = repository;
  }

  public call(
    period: { startDate: string, endDate: string },
    idUser: string | null,
    idSector: string | null,
    idClient: string | null
  ): Promise<ReportTicketEntity> {
    return this._repository.get(period, idUser, idSector, idClient);
  }
}
